import { Auditable } from '@peca/backoffice/models/auditable.model';
import { PurchaseOrderStatus } from './purchase-order-status.model';
import { ReasonRemoveOrder } from '../../values/reson-remove-order.value';

export enum PurchaseOrderInvoiceStatus {
  PENDING = 'PENDING',
  AUTOMATIC_ASSOCIATION = 'AUTOMATIC_ASSOCIATION',
  MANUAL_ASSOCIATION = 'MANUAL_ASSOCIATION',
  HIDDEN = 'HIDDEN',
}

export interface PurchaseOrder extends Auditable {
  id: string;
  status: PurchaseOrderStatus;
  amount: number;
  branch: {
    id: number;
    code: string;
    externalReference: string;
    companyName: string;
    businessUnit: string;
    tradingName: string;
    commercialName: string;
    address: {
      zipCode: string;
      street: string;
      number: string;
      complement: string;
      neighborhood: string;
      state: string;
      city: string;
      description: string;
      latitude: string;
      longitude: string;
    };
    contact: {
      type: string;
      contact: string;
    };
  };
  fiscalArchived: boolean;
  syncedToErp: boolean;
  reason: string;
  fiscalArchivedJustification: ReasonRemoveOrder;
  invoice: {
    id?: string;
    code?: string;
    amount: number;
    emittedAt: string;
    status: PurchaseOrderInvoiceStatus;
  } | null;
  order?: {
    id: string;
    commerceReference: string;
  };
  metadata?: {
    failureAt: Date;
    integrateAt: Date;
  };
}
